var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobIdv = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5990_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8074 47.99C35.14 47.7902 31.7905 44.1473 28.0073 42.4596C24.2242 40.7718 20.0238 40.9956 18.5843 39.3119C17.1749 37.6145 18.5482 34.0177 20.2364 31.1115C21.9164 28.2272 23.9333 26.0417 26.8743 23.6535C29.8153 21.2653 33.7325 18.669 36.9845 19.3113C40.2583 19.9618 42.9271 23.8236 45.0409 28.1008C47.1767 32.3861 48.7794 37.095 47.6005 41.0384C46.4216 44.9818 42.4447 48.2034 38.8074 47.99Z",
    fill: "#FA7B6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6316 19.0376C24.6314 16.5539 22.6173 14.5405 20.1335 14.5405C17.6499 14.5406 15.6366 16.554 15.6365 19.0376C15.6365 21.5213 17.6499 23.5355 20.1335 23.5356V25.0356L19.825 25.0278C16.6562 24.8671 14.1365 22.2462 14.1365 19.0376C14.1366 15.7255 16.8215 13.0406 20.1335 13.0405C23.4457 13.0405 26.1314 15.7255 26.1316 19.0376L26.1238 19.3462C25.9633 22.5151 23.3424 25.0356 20.1335 25.0356V23.5356C22.6174 23.5356 24.6316 21.5214 24.6316 19.0376Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3998 21.4049C32.3998 14.6305 26.9084 9.13847 20.1342 9.13828C13.3597 9.13828 7.86755 14.6304 7.86755 21.4049C7.86775 28.1792 13.3598 33.6705 20.1342 33.6705V35.1705L19.7787 35.1666C12.4578 34.9812 6.55768 29.0802 6.37244 21.7594L6.36755 21.4049C6.36755 13.802 12.5313 7.63828 20.1342 7.63828L20.4886 7.64316C27.9275 7.83139 33.8998 13.9206 33.8998 21.4049L33.8959 21.7594C33.7077 29.1981 27.6182 35.1703 20.1342 35.1705V33.6705C26.9083 33.6703 32.3996 28.179 32.3998 21.4049Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1342 26.2689C23.8518 26.269 27.0911 28.3118 28.7933 31.3323L27.4867 32.0687C26.0395 29.5006 23.2886 27.769 20.1342 27.7689C16.9795 27.7689 14.2279 29.5004 12.7806 32.0687L11.474 31.3323C13.1762 28.3116 16.4163 26.2689 20.1342 26.2689Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4725 39.4093L29.678 30.5197L30.7257 29.2476L41.5201 38.1371L40.4725 39.4093Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5990_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobIdv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlobIDV.75459d5e288cf25ddc04605f420b1d2b.svg";